// extracted by mini-css-extract-plugin
export default {"box":"FormLayout_box__wdT4y","gap":"FormLayout_gap__B2RBD","content":"FormLayout_content__t-0B-"};